import { PageHeader } from '@ant-design/pro-layout';
import { DoubleLeftOutlined } from '@ant-design/icons';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import { HeaderLogoLayout } from './header-logo-layout';
import { useFeatureFlags } from "../../../../shared/feature-flag-react-lite";

export const LandingPageHeader = () => {
  const { GetFeatureFlagByName } = useFeatureFlags();
  const screens = useBreakpoint();

  const myintealthServiceCatalogLinkVisible = GetFeatureFlagByName("MYINTEALTH_SERVICE_CATALOG_LINK_VISIBLE_UI_APPLICANT_PORTAL");

  return (
    <>
      <HeaderLogoLayout />
      <PageHeader style={{ backgroundColor: '#3f4373' }}>
        {myintealthServiceCatalogLinkVisible === "true" ? (
          <div style={{ marginLeft: screens.md ? '9px' : '-10px', paddingBottom:"12px" }}>
            <a href="https://www.intealth.org" style={{ color: 'white', fontSize: '18px' }}>
              <DoubleLeftOutlined /> MyIntealth Service Catalog
            </a>
          </div>
        ) : (
          <div style={{ height: '40px' }} />
        )}
      </PageHeader>
    </>
  );
};
